



















import { defineComponent, ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import usePager from "@/hooks/usePager";
import providers from "@/lib/api";
import BasePage from "@/components/BasePage";
import EmptyContent from "@/components/EmptyContent";
import InfiniteScroll from "@/components/InfiniteScroll";
import PageTitle from "@/components/PageTitle";
import MassMessageStatView from "./components/MassMessageStatView";
import UnsendConfirm from "./components/UnsendConfirm";

export default defineComponent({
  name: "PageMassMessageStat",
  components: { UnsendConfirm, InfiniteScroll, BasePage, PageTitle, EmptyContent, MassMessageStatView },
  setup() {
    const { authUserStrict: user } = useAuthUser();
    const loading = ref(false);
    const unsendId = ref<string | null>(null);
    const unsendPaid = ref<boolean>(false);
    const unsendMessageConfirm = ref(false);

    const { enableScroll, items, getNextPage, getFirstPage } = usePager(page =>
      providers.MassMessageStatProvider.search({
        data: {
          senderId: user.value.id,
          page,
          size: 5,
          sort: "TIME,DESC",
        },
      })
    );

    const getData = () => {
      loading.value = true;
      getFirstPage().finally(() => (loading.value = false));
    };

    const unsendMessage = async () => {
      if (!unsendId.value) return;
      loading.value = true;
      try {
        const status = await providers.MassMessageStatProvider.unsend({ id: unsendId.value });
        if (status) {
          const item = items.value.find(item => item.id === unsendId.value);
          if (item) item.unsended = true;
        }
      } finally {
        loading.value = false;
        unsendMessageConfirm.value = false;
      }
    };

    const unsendMessageShow = (data: { id: string; paid: boolean }) => {
      unsendMessageConfirm.value = true;
      unsendId.value = data.id;
      unsendPaid.value = data.paid;
    };

    getData();

    return {
      loading,
      items,
      enableScroll,
      getNextPage,
      unsendMessage,
      unsendId,
      unsendPaid,
      unsendMessageConfirm,
      unsendMessageShow,
    };
  },
});
